// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M 13.93 5.35 C 13.52 3.64 12.25 2.27 10.59 1.74 C 10.11 1.58 9.59 1.5 9.05 1.5 H 7.51 C 6.87 1.5 6.36 2.01 6.36 2.65 V 9.97 C 6.36 10.82 7.05 11.51 7.9 11.51 H 12.52 C 13.37 11.51 14.06 10.82 14.06 9.97 V 6.5 C 14.06 6.11 14.01 5.72 13.93 5.35 Z M 10.59 1.74 V 3.81 C 10.59 4.66 11.28 5.35 12.13 5.35 H 13.93',
  'M4.15 4.49H2.65C2.01 4.49 1.5 5 1.5 5.64V12.96C1.5 13.81 2.19 14.5 3.04 14.5H7.66C8.26 14.5 8.77 14.16 9.03 13.67',
];
